export const namespace = "area/";
export const SET_POS = "SET_POS";
